// The Hub template's renderer for every block type.
//
// Hub is the public hub page (/hub/{slug}, DailyReportShow.vue) grown
// into a whole website: the org's colour as a header band, white cards
// on a pale ground, small uppercase eyebrows, status pills. Like
// Backyard it is built ON Trailhead: Trailhead's components already
// draw every type through a small set of classes (th-card, th-btn,
// th-pill, th-h2 …), so hub.css redraws those classes and every block
// follows. Five blocks have a SHAPE of their own in the design and are
// drawn here: the menu, the hero, the page header, the stats bar and
// the footer.
//
// Spread first, then the overrides, so a type Trailhead learns to draw
// tomorrow is drawn here tomorrow too. sitetemplates_verify resolves
// the spread and still fails on a gap.
//
// Every class hub.css styles is scoped under .tpl-hub, which only a Hub
// site root wears (templates.js gives it BOTH classes, so Trailhead's
// own rules keep holding its layout together).

import { TRAILHEAD_COMPONENTS } from '../Trailhead/index.js';
import './hub.css';
import HubMenu from './HubMenu.vue';
import HubHero from './HubHero.vue';
import HubPageHeader from './HubPageHeader.vue';
import HubStats from './HubStats.vue';
import HubFooter from './HubFooter.vue';

export const HUB_COMPONENTS = {
    ...TRAILHEAD_COMPONENTS,
    menu: HubMenu,
    hero: HubHero,
    page_header: HubPageHeader,
    stats: HubStats,
    footer: HubFooter,
};
